<template lang="pug">
nav#navBar(ref="navBar")
    .bq-bar
        router-link.bq-bar-logo(v-if="!isServicePage" to="/")
            //- On home the wordmark is dropped and the icon IS the link, so the
            //- alt has to name it there; everywhere else the text does and the
            //- icon is decorative (alt="").
            span.bq-logo-full(title="Skapi" translate="no")
                img.bq-logo-icon(src="/skapi-logo-cut-small.png" alt='Skapi logo')
                //- Black wordmark; dark mode inverts it through the icon token
                //- (see .bq-logo-text), so one file serves both themes.
                img.bq-logo-text(src="/font-b.png" alt='Skapi Text')
                //- span(style='font-size: 1.7em;text-shadow: var(--bq-text-shadow);') Skapi
            span.bq-logo-short(title="Skapi" translate="no")
                img.bq-logo-icon(src="/skapi-logo-cut-small.png" alt="Skapi logo")
        .bq-bar-service(v-if="isServicePage")
            //- ONE link, not two: the chevron and the project name both led back to the
            //- project list, but as separate targets with a dead gap between them. The
            //- whole strip is the link now, chevron, gap and name together.
            router-link.bq-bar-service-link(:to="{ name: 'my-projects' }" translate="no" title="Back to Project List")
                span.material-symbols-outlined.bq-bar-service-back(translate="no") arrow_back_ios_new
                span.bq-bar-service-name(translate="no") {{ currentService?.service?.name }}
        .bq-bar-right
            .bq-desktop-nav
                button.bq-theme-toggle(@click="toggleDark" data-track="landing_theme_toggle" :data-track-id="isDark ? 'light' : 'dark'" role="switch" :aria-checked="isDark" :class="{ 'is-dark': isDark }" :title="isDark ? 'Switch to light mode' : 'Switch to dark mode'" aria-label="Toggle dark mode")
                    span.bq-theme-knob(aria-hidden="true")
                    span.material-symbols-outlined.bq-theme-icon.bq-theme-sun(translate="no") light_mode
                    span.material-symbols-outlined.bq-theme-icon.bq-theme-moon(translate="no") dark_mode
                //- router-link.bq-pill(v-if="isServicePage" translate="no" :to="`/my-projects/${currentService.id}`" style="margin-bottom:0;max-width: 22rem;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;") {{ currentService?.service?.name || "..." }}
                //- template(v-if="route.name === 'home'")
                //-     a.bq-bar-link(href="#how" @click.prevent="e=>scrollToSection(e)") How it works
                //-     a.bq-bar-link(href="#why" @click.prevent="e=>scrollToSection(e)") Why
                //-     a.bq-bar-link(href="#cases" @click.prevent="e=>scrollToSection(e)") Use cases
                //- router-link.bq-bar-link(v-if="!isServicePage" to="/articles" :class="{ 'bq-bar-link--active': route.name === 'articles' || route.name === 'article' }") Articles
                template(v-if="user?.user_id")
                    //- router-link.bq-bar-link(to="/my-projects" v-if='route.path.startsWith("/my-projects/") || route.name === "home" || route.name === "account-settings"') [My Projects]
                    //- .bq-bar-project(v-if="isServicePage")
                    //-     span.bq-bar-project-label Project:&nbsp;
                    //-     router-link.bq-bar-project-name(:to="`/my-projects/${currentService.id}`" translate="no") {{ currentService?.service?.name }}
                    .bq-bar-profile(@mouseenter="showProfileDropdown" @mouseleave="hideProfileDropdown")
                        span.bq-bar-avatar(translate="no") {{ userInitial }}
                        .bq-bar-dropdown(v-show="profileDropdownVisible")
                            .bq-bar-dropdown-email
                                span.user-id(translate="no") {{ userEmail }}
                                .bq-bar-dropdown-name(translate="no") {{ user?.name || "" }}
                            .bq-bar-dropdown-item(@click="()=>{navigateToMyProjects();clickProfileDropdown();}" :class="{ active: route.name === 'my-projects' }") My Projects
                            .bq-bar-dropdown-item(@click="()=>{navigateToAccountPage();clickProfileDropdown();}" :class="{ active: route.path === '/account-settings' }") Account
                            .bq-bar-dropdown-item(@click="()=>{clickProfileDropdown();openBillingPage();}") Billing
                            .bq-bar-dropdown-item(@click="()=>{navigateToArticlePage();clickProfileDropdown();}" :class="{ active: route.name === 'articles' || route.name === 'article' }") Articles
                            //- Leaves the app, so it is a real anchor rather than a
                            //- router push like the rows around it.
                            a.bq-bar-dropdown-item(href="https://docs.skapi.com/introduction/getting-started.html" target="_blank" rel="noopener" @click="clickProfileDropdown") Docs
                            
                            .bq-bar-dropdown-item(@click="()=>{logout();clickProfileDropdown();}") Logout
                template(v-else)
                    router-link.bq-bar-link(to="/login" data-track="nav_login") [Login]
                    router-link.btn(to="/signup" data-track="nav_signup") Sign Up
            .bq-mobile-nav
                button.bq-theme-toggle(@click="toggleDark" data-track="landing_theme_toggle" :data-track-id="isDark ? 'light' : 'dark'" role="switch" :aria-checked="isDark" :class="{ 'is-dark': isDark }" :title="isDark ? 'Switch to light mode' : 'Switch to dark mode'" aria-label="Toggle dark mode")
                    span.bq-theme-knob(aria-hidden="true")
                    span.material-symbols-outlined.bq-theme-icon.bq-theme-sun(translate="no") light_mode
                    span.material-symbols-outlined.bq-theme-icon.bq-theme-moon(translate="no") dark_mode
                button.bq-bar-burger(@click="openMoMenu" aria-label="Menu") &#9776;
    .bq-mo-overlay(:class="{ open: moMenuOpen }")
        .bq-mo-header
            //- The drawer keeps the same full Skapi lockup as the main mobile bar.
            router-link.bq-bar-logo(to="/" @click="closeMobileMenu")
                span.bq-logo-full(title="Skapi" translate="no")
                    img.bq-logo-icon(src="/skapi-logo-cut-small.png" alt="Skapi logo")
                    img.bq-logo-text(src="/font-b.png" alt="Skapi Text")
            button.bq-mo-close(@click="closeMobileMenu" aria-label="Close") &times;
        .bq-mo-body
            
            //- template(v-if="route.name === 'home'")
            //-     a.bq-mo-link(href="#how" @click.prevent="e=>scrollToSection(e)") How it works
            //-     a.bq-mo-link(href="#why" @click.prevent="e=>scrollToSection(e)") Why
            //-     a.bq-mo-link(href="#cases" @click.prevent="e=>scrollToSection(e)") Use cases
                //- .bq-mo-divider
            template(v-if="user?.user_id")
                template(v-if="isServicePage")
                    //- .bq-mo-divider
                    router-link.bq-mo-link(:to="`/my-projects/${currentService.id}`" @click="closeMobileMenu" :class="{ 'bq-mo-link--active': route.name === 'dashboard' }")
                        span.material-symbols-outlined.bq-mo-link-icon(translate="no" aria-hidden="true") settings
                        span Settings
                    router-link.bq-mo-link(:to="`/my-projects/${currentService.id}/records`" @click="closeMobileMenu" :class="{ 'bq-mo-link--active': route.name === 'records' }")
                        span.material-symbols-outlined.bq-mo-link-icon(translate="no" aria-hidden="true") database
                        span Database
                    router-link.bq-mo-link(:to="`/my-projects/${currentService.id}/users`" @click="closeMobileMenu" :class="{ 'bq-mo-link--active': route.name === 'users' }")
                        span.material-symbols-outlined.bq-mo-link-icon(translate="no" aria-hidden="true") group
                        span Users
                    router-link.bq-mo-link(:to="`/my-projects/${currentService.id}/clientsecret`" @click="closeMobileMenu" :class="{ 'bq-mo-link--active': route.name === 'clientsecret' }")
                        span.material-symbols-outlined.bq-mo-link-icon(translate="no" aria-hidden="true") key
                        span Secret Keys
                    router-link.bq-mo-link(:to="`/my-projects/${currentService.id}/openid`" @click="closeMobileMenu" :class="{ 'bq-mo-link--active': route.name === 'openid' }")
                        span.material-symbols-outlined.bq-mo-link-icon(translate="no" aria-hidden="true") fingerprint
                        span Open ID
                    router-link.bq-mo-link(:to="`/my-projects/${currentService.id}/tickets`" @click="closeMobileMenu" :class="{ 'bq-mo-link--active': route.name === 'tickets' }")
                        span.material-symbols-outlined.bq-mo-link-icon(translate="no" aria-hidden="true") confirmation_number
                        span Tickets
                    router-link.bq-mo-link(:to="`/my-projects/${currentService.id}/mail`" @click="closeMobileMenu" :class="{ 'bq-mo-link--active': route.name === 'mail' }")
                        span.material-symbols-outlined.bq-mo-link-icon(translate="no" aria-hidden="true") mail
                        span Automated Emails
                    router-link.bq-mo-link(:to="`/my-projects/${currentService.id}/newsletter`" @click="closeMobileMenu" :class="{ 'bq-mo-link--active': route.name === 'newsletter' }")
                        span.material-symbols-outlined.bq-mo-link-icon(translate="no" aria-hidden="true") newspaper
                        span Newsletters
                    router-link.bq-mo-link(:to="`/my-projects/${currentService.id}/hosting`" @click="closeMobileMenu" :class="{ 'bq-mo-link--active': route.name === 'hosting' }")
                        span.material-symbols-outlined.bq-mo-link-icon(translate="no" aria-hidden="true") public
                        span Web Hosting
                //- br
                .bq-mo-divider(v-if="isServicePage")
                router-link.bq-mo-link(to="/my-projects" @click="closeMobileMenu" :class="{ 'bq-mo-link--active': route.name === 'my-projects' }") My Projects
                .bq-mo-link(@click="navigateToAccountPage" :class="{ 'bq-mo-link--active': route.path === '/account-settings' }") Account
                .bq-mo-link(@click="()=>{closeMobileMenu();openBillingPage();}") Billing
                router-link.bq-mo-link(to="/articles" @click="closeMobileMenu" :class="{ 'bq-mo-link--active': route.name === 'articles' || route.name === 'article' }") Articles
                a.bq-mo-link(href="https://docs.skapi.com/introduction/getting-started.html" target="_blank" rel="noopener" @click="closeMobileMenu") Docs
                .bq-mo-link(@click="logout") Logout
            template(v-else)
                //- .bq-mo-divider
                router-link.bq-mo-link(to="/articles" @click="closeMobileMenu" :class="{ 'bq-mo-link--active': route.name === 'articles' || route.name === 'article' }") Articles
                a.bq-mo-link(href="https://docs.skapi.com/introduction/getting-started.html" target="_blank" rel="noopener" @click="closeMobileMenu") Docs
                router-link.bq-mo-link(to="/login" @click="closeMobileMenu" data-track="nav_login") Login
                router-link.bq-mo-link(to="/signup" @click="closeMobileMenu" data-track="nav_signup") Sign Up
            br
            .bq-mo-footer
                a.bq-mo-footer-link(href="/pp.html" target="_blank") Terms of service / Privacy policy
                .bq-mo-footer-company {{ new Date().getFullYear() }} BROADWAYINC PTE. LTD. Singapore.
                .bq-mo-footer-email support&#64;broadwayinc&#46;com
                .bq-mo-footer-icons
                    a.bq-mo-footer-icon(href="https://github.com/broadwayinc/skapi-js" target="_blank" rel="noopener")
                        img.bq-mo-footer-svg(:src="iconGithub" alt="GitHub")
                    a.bq-mo-footer-icon(href="http://www.tiktok.com/@skapi_api" target="_blank")
                        img.bq-mo-footer-svg(:src="iconTiktok" alt="TikTok")
                    a.bq-mo-footer-icon(href="https://www.instagram.com/skapi_api" target="_blank")
                        img.bq-mo-footer-svg(:src="iconInstagram" alt="Instagram")
                    a.bq-mo-footer-icon(href="https://www.youtube.com/@skapi_official" target="_blank")
                        img.bq-mo-footer-svg(:src="iconYoutube" alt="YouTube")
                    a.bq-mo-footer-icon(href="https://x.com/skapi_api" target="_blank")
                        img.bq-mo-footer-svg(:src="iconX" alt="X")
                    a.bq-mo-footer-icon(href="https://www.linkedin.com/company/skapi-backend-api/" target="_blank")
                        img.bq-mo-footer-svg(:src="iconLinkedin" alt="LinkedIn")
                    a.bq-mo-footer-icon(href="https://www.facebook.com/profile.php?id=61577236221327" target="_blank")
                        img.bq-mo-footer-svg(:src="iconFacebook" alt="Facebook")
                    a.bq-mo-footer-icon(href="https://dev.to/skapi_api" target="_blank")
                        img.bq-mo-footer-svg(:src="iconDevto" alt="Dev.to")
</template>

<script setup>
import { useRoute, useRouter } from "vue-router";
import { computed, onMounted, ref } from "vue";
import { skapi } from "@/main";
import { user, customer, openBillingPortal } from "@/code/user";
import { currentService } from "@/views/project-list";
import { setAutoHide } from "./navBar-autohide.ts";
import {
    fullScreenLoader,
    removeFullScreenLoader,
} from "@/components/jsComponents";
import iconGithub from "@/assets/img/landingpage/icon_github.svg";
import iconTiktok from "@/assets/img/landingpage/icon_tiktok.svg";
import iconInstagram from "@/assets/img/landingpage/icon_instagram.svg";
import iconYoutube from "@/assets/img/landingpage/icon_youtube.svg";
import iconX from "@/assets/img/landingpage/icon_x.svg";
import iconLinkedin from "@/assets/img/landingpage/icon_linkedin.svg";
import iconFacebook from "@/assets/img/landingpage/icon_facebook.svg";
import iconDevto from "@/assets/img/landingpage/icon_devto.svg";
const router = useRouter();
const route = useRoute();

let navBar = ref(null);
const userEmail = ref(user?.email || "");

const isServicePage = computed(() => {
    return !!currentService.value && ['dashboard', 'records', 'users', 'clientsecret', 'openid', 'tickets', 'mail', 'newsletter', 'hosting'].includes(String(route.name));
});

const userInitial = computed(() => {
    const nameInitial = user?.name?.trim()?.charAt(0);
    if (nameInitial) {
        return nameInitial.toUpperCase();
    }
    return userEmail.value.charAt(0).toUpperCase();
});

const THEME_KEY = 'bq-theme';
const isDark = ref(false);

// Theme follows the OS `prefers-color-scheme` until the user explicitly
// toggles it; that choice is persisted under THEME_KEY and wins from then on,
// even if the OS setting later changes. Keep this in sync with the pre-paint
// resolver in index.html. The browser chrome colour (index.html's one
// theme-color tag) follows the theme: the @paper value of each.
const prefersDark = () => !!(window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches);

const syncThemeColor = (dark) => {
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', dark ? '#0b0e14' : '#ffffff');
};

const applyTheme = (dark) => {
    isDark.value = dark;
    document.documentElement.dataset.theme = dark ? 'dark' : 'light';
    syncThemeColor(dark);
};

const initTheme = () => {
    const stored = localStorage.getItem(THEME_KEY);
    applyTheme(stored ? stored === 'dark' : prefersDark());
};

const toggleDark = () => {
    applyTheme(!isDark.value);
    try { localStorage.setItem(THEME_KEY, isDark.value ? 'dark' : 'light'); } catch {}
};

const profileDropdownVisible = ref(false);
let profileHideTimeout = null;
let profileClickClosedAt = 0;
const moMenuOpen = ref(false);

let openMoMenu = () => {
    moMenuOpen.value = !moMenuOpen.value;
    document.body.style.overflow = moMenuOpen.value ? "hidden" : "auto";
};

// The provider's customer portal; see openBillingPortal in code/user.ts.
let openBillingPage = () => openBillingPortal();

let navigateToAccountPage = () => {
    closeMobileMenu();
    router.push({ path: "/account-settings" });
};
let navigateToArticlePage = () => {
    closeMobileMenu();
    router.push({ path: "/articles" });
};
let navigateToMyProjects = () => {
    closeMobileMenu();
    router.push({ path: "/my-projects" });
};
let logout = () => {
    skapi.util.terminatePendingRequests();
    skapi.logout().then(() => {
        router.push({ path: "/" });
    });
    closeMobileMenu();
};

const closeMobileMenu = () => {
    moMenuOpen.value = false;
    document.body.style.overflow = "auto";
};

const scrollToSection = (e) => {
    const sectionId = e.target.getAttribute("href").substring(1);
    const section = document.getElementById(sectionId);
    if (section) {
        const remOffset =
            4 * parseFloat(getComputedStyle(document.documentElement).fontSize);
        const scrollY = section.offsetTop - remOffset;
        window.scrollTo({ top: scrollY, behavior: "smooth" });
    }

    closeMobileMenu();
};

// profile dropdown
const clickProfileDropdown = () => {
    if (profileHideTimeout) {
        clearTimeout(profileHideTimeout);
        profileHideTimeout = null;
    }
    if (profileDropdownVisible.value) {
        profileDropdownVisible.value = false;
        profileClickClosedAt = Date.now();
    } else {
        profileDropdownVisible.value = true;
    }
};

const showProfileDropdown = () => {
    if (Date.now() - profileClickClosedAt < 300) return;
    if (profileHideTimeout) {
        clearTimeout(profileHideTimeout);
        profileHideTimeout = null;
    }
    profileDropdownVisible.value = true;
};

const hideProfileDropdown = () => {
    // 약간의 지연을 두어 사용자가 popup으로 마우스를 이동할 시간을 제공
    profileHideTimeout = setTimeout(() => {
        profileDropdownVisible.value = false;
    }, 240);
};

onMounted(() => {
    initTheme();
    setAutoHide(navBar.value, 3);
    // Live-follow the OS while the user has never made an explicit choice.
    window.matchMedia?.('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
        if (!localStorage.getItem(THEME_KEY)) applyTheme(e.matches);
    });
});

</script>

<style lang="less" scoped>
@import "@/assets/less/bq-tokens.less";

#navBar {
    position: var(--nav-position, fixed);
    top: var(--nav-top, 0px);
    left: 0;
    z-index: 99999999;
    width: 100%;
    height: 4rem;
    background: @paper;
    border-bottom: 1px solid @line;
    font-family: @mono;
    font-size: 0.875rem;
    color: @ink;
}

.bq-bar {
    max-width: 1200px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 2rem;
}

.bq-bar-logo {
    font-weight: 700;
    font-size: 1.1rem;
    letter-spacing: 0.04em;
    color: @ink;
    text-decoration: none;

    &:hover {
        text-decoration: none;
    }
}

.bq-logo-full {
    display: inline-flex;
    align-items: center;
    gap: 0.45rem;
}

.bq-logo-short {
    display: none;
}

/* width: auto, so the width/height attributes only lend their aspect ratio
   (no layout shift while the file loads) and the size still follows the CSS
   height, as before they were added. */
.bq-logo-icon {
    width: auto;
    height: 2.15em;
}

/* The wordmark is pure black on transparency, so the monochrome-icon token
   (0 in light, 1 in dark) turns it white for dark mode without a second
   file; alpha is untouched, so the edges stay clean. */
.bq-logo-text {
    width: auto;
    height: 1.56em;
    margin-top: 0.12em;
    margin-left: 0.25em;
    filter: invert(var(--bq-icon-invert));
}

.bq-desktop-nav {
    display: flex;
    align-items: center;
    gap: 1.5rem;
}

.bq-mobile-nav {
    display: none;
    align-items: center;
    gap: 1.5rem;
}

.bq-bar-right {
    display: flex;
    align-items: center;
    gap: 1.5rem;
}

.bq-bar-link {
    color: @muted;
    text-decoration: none;
    font-size: 0.82rem;
    letter-spacing: 0.04em;
    transition: color 0.15s;

    &:hover {
        color: @ink;
        text-decoration: underline;
    }

    &--active {
        color: @pink;
    }
}

/* ─── profile dropdown ─── */
.bq-bar-profile {
    position: relative;
    cursor: pointer;
}

.bq-bar-avatar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    border: 1px solid @pink;
    background-color: @light-pink;
    color: @paper;
    font-size: 0.78rem;
    font-weight: 700;
    user-select: none;
}

.bq-bar-dropdown {
    position: absolute;
    // top: calc(100% + 0.5rem);
    // right: 0;
    min-width: 14rem;
    top: calc(100% - 0.25rem);
    right: 0.25rem;
    background: @paper;
    border: 1px solid @muted;
    padding: 0.2rem;
    z-index: 1000;
    font-size: 0.82rem;
    box-shadow: 2px 2px 0 var(--bq-shadow);
}

.bq-bar-dropdown-email {
    padding: 0.75rem 1rem;
    margin-bottom: 0.2rem;
    border-bottom: 1px solid @line;
    color: @muted;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: default;

    .user-id {
        color: @ink;
    }

    .bq-bar-dropdown-name {
        display: block;
        margin-top: 0.35rem;
        font-size: 0.7rem;
        color: @muted;
        text-decoration: none;
        cursor: default;
    }
}

.bq-bar-dropdown-item {
    display: block;
    padding: 0.6rem 1rem;
    cursor: pointer;
    transition: background 0.1s, text-shadow 0.1s;
    color: @ink;
    text-decoration: none;

    /* The label lifts with the row: the text version of the hard offset
       shadow the cards and headings carry. */
    &:hover {
        background: @hover-bg;
        text-decoration: none;
        text-shadow: var(--bq-text-shadow);
    }

    /* Current page, in the same words the side nav and the mobile menu use:
       brand blue, a heavier label and a bar down its leading edge, inset so it
       rides inside the panel's own border. No tint: the row keeps the plain
       paper the others have, so hovering it still reads as a hover. */
    &.active {
        color: @pink;
        font-weight: 600;
        box-shadow: inset 3px 0 0 @pink;
        text-shadow: var(--bq-text-shadow);
    }
}

/* ─── light / dark theme toggle ─── */
.bq-theme-toggle {
    all: unset;
    box-sizing: border-box;
    position: relative;
    display: inline-flex;
    flex-shrink: 0;
    width: 52px;
    height: 26px;
    border: 1px solid @line;
    border-radius: 13px;
    background: @hover-bg;
    cursor: pointer;
    vertical-align: middle;
    transition: border-color 0.15s, background 0.15s;

    &:hover {
        border-color: @pink;
    }

    &:focus-visible {
        outline: 2px solid @pink;
        outline-offset: 2px;
    }
}

/* sliding disc: a "spotlight" under the active icon */
.bq-theme-knob {
    position: absolute;
    top: 2px;
    left: 2px;
    z-index: 1;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: @paper;
    border: 1px solid @line;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
    transition: transform 0.22s cubic-bezier(0.4, 0.1, 0.2, 1);
}

/* sun (left) + moon (right), sitting above the knob */
.bq-theme-icon {
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    font-size: 15px;
    pointer-events: none;
    transition: color 0.15s;

    &.bq-theme-sun {
        left: 0;
        color: @pink; /* active in light mode */
    }

    &.bq-theme-moon {
        right: 0;
        color: @muted; /* inactive in light mode */
    }
}

.bq-theme-toggle.is-dark {
    .bq-theme-knob {
        transform: translateX(26px);
    }

    .bq-theme-sun {
        color: @muted;
    }

    .bq-theme-moon {
        color: @pink;
    }
}

/* ─── mobile burger ─── */
.bq-bar-burger {
    all: unset;
    cursor: pointer;
    font-size: 1.5rem;
    line-height: 1;
    color: @pink;
}

.bq-mo-overlay {
    position: fixed;
    top: 0;
    right: -100%;
    width: 100%;
    height: 100vh;
    background: @paper;
    z-index: 999999;
    transition: right 0.25s ease;
    display: flex;
    flex-direction: column;

    &.open {
        right: 0;
    }
}

.bq-mo-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 2rem;
    height: 4rem;
    border-bottom: 1px solid @line;
}

.bq-mo-close {
    all: unset;
    cursor: pointer;
    font-size: 1.75rem;
    line-height: 1;
    color: @muted;
}

.bq-mo-body {
    padding: 1rem 0;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
}

.bq-mo-link {
    /* Flex so the project rows can lead with an icon; rows without one are a
       single text child and render exactly as the old display: block did. */
    display: flex;
    align-items: center;
    gap: 0.6rem;
    padding: 0.85rem 2rem;
    color: @ink;
    text-decoration: none;
    font-size: 0.95rem;
    cursor: pointer;

    &:hover {
        background: @hover-bg;
        text-decoration: none;
    }

    &--active {
        color: @pink;
        font-weight: 600;
        /* The colour change alone was easy to miss on a phone; the inset bar marks
           the current page the way the desktop side nav does. */
        box-shadow: inset 3px 0 0 @pink;
        text-shadow: var(--bq-text-shadow);

        .bq-mo-link-icon {
            text-shadow: none;
        }
    }
}

.bq-mo-divider {
    height: 1px;
    background: @line;
    margin: 0.5rem 2rem;
}

.bq-mo-footer {
    // margin-top: 4rem;
    padding: 1.25rem 2rem 1.5rem;
    // border-top: 1px solid @line;
}

.bq-mo-footer-link {
    display: block;
    color: @muted;
    font-size: 0.8rem;
    text-decoration: none;

    &:hover {
        color: @ink;
        text-decoration: underline;
    }
}

.bq-mo-footer-company {
    margin-top: 0.3rem;
    font-size: 0.75rem;
    color: @muted;
}

.bq-mo-footer-email {
    margin-top: 0.8rem;
    font-size: 0.85rem;
    color: @muted;
}

.bq-mo-footer-icons {
    margin-top: 0.5rem;
    display: flex;
    flex-wrap: wrap;
    gap: 0.45rem;
}

.bq-mo-footer-icon {
    display: inline-block;
}

.bq-mo-footer-svg {
    display: block;
    width: 1.5rem;
    height: 1.5rem;
    object-fit: contain;
    filter: brightness(0) saturate(100%) invert(var(--bq-icon-invert));
    opacity: 0.82;
}

.bq-bar-service {
    display: flex;
    align-items: center;
    min-width: 0;
    flex: 1;
}

/* The one click target of the strip: the chevron and the name together, and ONLY
   them. It is sized by its content (flex 0 1 auto, never 1): the row's remaining
   width belongs to .bq-bar-service, not to the link, so a click beside the name does
   nothing. It can still shrink below its text (min-width: 0, max-width: 100%), which
   is what lets a long name truncate inside it. The global a:hover underline is kept
   off it: the name never underlined before. */
.bq-bar-service-link {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex: 0 1 auto;
    min-width: 0;
    max-width: 100%;
    margin-right: 1rem;
    color: @ink;
    text-decoration: none;
    cursor: pointer;

    &:hover {
        text-decoration: none;
    }
}

.bq-bar-service-back {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    font-size: 1.1rem;
    color: @ink;
}

/* No flex: 1 here any more: the name used to fill the row, which made the whole row
   its click target. The right margin moved onto the link, so the target ends with
   the text. */
.bq-bar-service-name {
    flex: 0 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 1.1rem;
    font-weight: 700;
    line-height: 1.3;
    color: @ink;
}

@media (max-width: 800px) {
    .bq-bar {
        padding: 0 1.25rem;
    }

    /* Keep the full Skapi lockup in the main navbar on non-project pages.
       The drawer header remains icon-only below. */
    .bq-bar > .bq-bar-logo .bq-logo-full {
        display: inline-flex;
        align-items: center;
    }

    .bq-bar > .bq-bar-logo .bq-logo-short {
        display: none;
    }

    .bq-mo-header .bq-logo-short {
        display: none;
    }

    .bq-mo-header .bq-logo-full {
        display: inline-flex;
        align-items: center;
    }

    /* Same side padding as .bq-bar above, so when the menu slides over the bar its
       icon lands exactly on the navbar icon (and the close button on the menu button).
       Heights already match: both rows are 4rem with a 1px bottom border. */
    .bq-mo-header {
        padding: 0 1.25rem;
    }

    .bq-desktop-nav {
        display: none;
    }

    .bq-mobile-nav {
        display: flex;
    }

    /* The theme toggle and menu button keep their full width; only the project
       name in the middle gives way when the row runs out of room. */
    .bq-bar-right {
        flex-shrink: 0;
    }

    .bq-bar-service {
        display: flex;
        align-items: center;
        min-width: 0;
        flex: 1;
        /* Stretch to the bar's full height (the bar centers its children at content
           height otherwise), so the link's align-self: stretch below reaches the whole
           bar and not just the text's height. */
        align-self: stretch;
    }

    /* Same hit-area treatment as the records media chevron, now on the whole link: it
       takes the bar's full height and absorbs the bar's 1.25rem left padding
       (padding-left + equal negative margin keeps the glyph exactly where it was),
       so a thumb at the screen edge, on the gap or on the name all leave the project. */
    .bq-bar-service-link {
        align-self: stretch;
        padding-left: 1.25rem;
        margin: 0 1rem 0 -1.25rem;
    }

    .bq-bar-service-back {
        display: inline-flex;
        align-items: center;
        font-size: 1.1rem;
        color: @ink;
        flex-shrink: 0;
    }

    /* The project name reads as the page header, in the same type as the settings
       page's .bq-section-title, with no box around it. It is one line only: a name
       too long for the row is cut with an ellipsis. flex-shrink with min-width: 0
       is what lets it get narrower than its text, so a long name truncates instead
       of pushing the theme toggle and menu button off the screen. */
    .bq-bar-service-name {
        display: block;
        flex: 0 1 auto;
        min-width: 0;
        margin: 0;
        font-size: 1.1rem;
        font-weight: 700;
        line-height: 1.3;
        color: @ink;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}

.bq-mo-link-icon {
    font-size: 1.1rem;
    opacity: 0.65;
}
</style>
